import React from 'react';
import { SparklesIcon, ArrowRightIcon } from '../lib/icons';
import { useReveal } from '../lib/useReveal';
const HOTMART = 'https://checkout.recursostop.shop/cart/45770493690052:1';
export function ClosingSection() {
  const [ref1, vis1] = useReveal();
  return <section className="relative bg-[#2d1f3d] text-white py-24 md:py-32 px-4 overflow-hidden" data-id="element-47">
      <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-[600px] h-[600px] bg-amber-500/10 rounded-full blur-[100px] pointer-events-none" data-id="element-48"></div>

      <div ref={ref1} className={`reveal container mx-auto max-w-3xl text-center relative z-10 ${vis1 ? 'is-visible' : ''}`} data-id="element-49">
        <div className="mb-8" data-id="element-50">
          <SparklesIcon className="w-8 h-8 text-amber-400 mx-auto mb-6 animate-pulse" data-id="element-51" />
        </div>

        <h2 className="text-3xl md:text-5xl font-serif font-bold mb-8 leading-tight" data-id="element-52">
          Reiki no te está buscando
          <br className="hidden md:block" data-id="element-53" />{' '}
          <span className="text-transparent bg-clip-text bg-gradient-to-r from-amber-200 via-white to-amber-200" data-id="element-54">
            por casualidad
          </span>
        </h2>

        <div className="relative inline-block mb-12" data-id="element-55">
          <div className="absolute -inset-1 bg-gradient-to-r from-amber-500 to-amber-300 rounded-lg blur opacity-20" data-id="element-56"></div>
          <p className="relative text-xl md:text-2xl text-gray-200 font-light leading-relaxed max-w-2xl mx-auto" data-id="element-57">
            "No necesitás más información. <br data-id="element-58" />
            Necesitás un sistema que te acompañe y te sostenga."
          </p>
        </div>

        <div data-id="element-59">
          <a href={HOTMART} target="_blank" rel="noopener noreferrer" className="cta-btn group relative inline-flex items-center gap-3 px-12 py-6 bg-gradient-to-r from-amber-500 via-yellow-500 to-amber-500 text-black font-extrabold text-xl md:text-2xl rounded-full shadow-[0_0_40px_rgba(245,158,11,0.4)] hover:shadow-[0_0_60px_rgba(245,158,11,0.6)] transition-all" data-id="element-60">
            <span data-id="element-61">Accedé ahora al MegaPack Reiki</span>
            <ArrowRightIcon className="w-6 h-6 group-hover:translate-x-1 transition-transform" data-id="element-62" />
            <div className="absolute inset-0 rounded-full bg-white/20 blur-md opacity-0 group-hover:opacity-100 transition-opacity" data-id="element-63"></div>
          </a>
        </div>

        <p className="mt-12 text-lg text-amber-200/80 font-serif italic" data-id="element-64">
          ✨ La sanación ya está en vos. Solo necesitás activarla.
        </p>
      </div>
    </section>;
}